const getDocumentUrl = (storagePath: string) => {
  if (!storagePath) return null;

  // If it's already a full URL, return as is
  if (storagePath.startsWith("http")) {
    return storagePath;
  }

  // If it starts with /storage/, convert to /storage/ URL
  if (storagePath.startsWith("/storage/")) {
    // Remove the leading /storage/ and build the URL
    const filename = storagePath.replace("/storage/", "");
    return `${
      process.env.REACT_APP_BASE_URL || "http://localhost:8000"
    }/storage/${filename}`;
  }

  // If it's just a filename, assume it's in storage
  return `${
    process.env.REACT_APP_BASE_URL || "http://localhost:8000"
  }/storage/${storagePath}`;
};

export default getDocumentUrl;
